<section>
  <div class="row">
    <div class="col-xl-10 col-xxl-8 col-12 client-add">
      <div class="sana-card">
        <a
          class="back-hint"
          role="link"
          [routerLink]="['../..']"
          tabindex="0">
          <i class="pi pi-chevron-left"></i> Zurück zum Start
        </a>

        <div class="sana-card-header">
          <span>Neuen Patienten anlegen</span>
        </div>

        <form
          [formGroup]="clientForm"
          (ngSubmit)="submit()">
          <div class="row gx-3">
            <div class="col-lg-3 col-md-6 sana-form-control">
              <label for="firstName">Vorname *</label>

              <input
                pInputText
                id="firstName"
                [formControl]="clientForm.controls.firstName"
                pSize="small"
                [fluid]="true"
                [pAutoFocus]="true"
                data-cy="sana-tp-client-add-firstname" />
            </div>

            <div class="col-lg-3 col-md-6 sana-form-control">
              <label for="lastName">Nachname *</label>

              <input
                pInputText
                id="lastName"
                [formControl]="clientForm.controls.lastName"
                pSize="small"
                [fluid]="true"
                data-cy="sana-tp-client-add-lastname" />
            </div>

            <div class="col-lg-3 col-md-6 sana-form-control">
              <label for="titlePrefix">Titel vorangestellt</label>

              <input
                pInputText
                id="titlePrefix"
                [formControl]="clientForm.controls.titlePrefix"
                pSize="small"
                [fluid]="true"
                data-cy="sana-tp-client-add-titlePrefix" />
            </div>

            <div class="col-lg-3 col-md-6 sana-form-control">
              <label for="titleSuffix">Titel nachgestellt</label>

              <input
                pInputText
                id="titleSuffix"
                [formControl]="clientForm.controls.titleSuffix"
                pSize="small"
                [fluid]="true"
                data-cy="sana-tp-client-add-titleSuffix" />
            </div>

            <div class="col-lg-3 col-md-6 sana-form-control">
              <label for="dateOfBirth">Geburtsdatum *</label>

              <p-date-picker
                id="dateOfBirth"
                [formControl]="clientForm.controls.dateOfBirth"
                [size]="'small'"
                selectionMode="single"
                [fluid]="true"
                [dateFormat]="'dd.mm.yy'"
                [firstDayOfWeek]="1"
                data-cy="sana-tp-client-add-birthdate"
                [minDate]="minDate"
                [maxDate]="today"
                [showTime]="false"
                [dataType]="'string'"></p-date-picker>

              <small id="dateOfBirth-help" class="form-help">dd.mm.yyyy</small>
            </div>

            <div class="col-lg-3 col-md-6 sana-form-control">
              <label for="socialSecurityNumber">SV-Nr. *</label>

              <p-inputgroup
                class="w-100">
                <input
                  pInputText
                  appOnlyNumber
                  id="socialSecurityNumber"
                  pSize="small"
                  fluid
                  [formControl]="clientForm.controls.socialSecurityNumber"
                  data-cy="sana-tp-client-add-svnr" />

                <p-inputgroup-addon [style]="{'padding': '4px 8px'}">{{ dateOfBirthSvNr }}</p-inputgroup-addon>
              </p-inputgroup>
            </div>

            <div class="col-lg-3 col-md-6 sana-form-control">
              <label for="email">E-Mail *</label>

              <input
                pInputText
                id="email"
                [formControl]="clientForm.controls.email"
                pSize="small"
                [fluid]="true"
                data-cy="sana-tp-client-add-email"
                type="email" />

              @if (clientForm.controls.email.hasError('alreadyInUse')) {
                <div class="invalid-feedback">
                  Diese E-Mail ist bereits vergeben.
                </div>
              }
            </div>

            <div class="col-lg-3 col-md-6 sana-form-control">
              <label for="phone">Telefonnummer</label>

              <input
                pInputText
                id="phone"
                [formControl]="clientForm.controls.phoneNumber"
                pSize="small"
                [fluid]="true"
                data-cy="sana-tp-client-add-phone"
                type="tel" />

              <small id="phone-help" class="form-help">Im Format: +43XXXXXXXXXX</small>

              @if (clientForm.controls.phoneNumber.hasError('pattern')) {
                <div class="invalid-feedback">
                  Bitte geben Sie eine gültige internationale Telefonnummer mit + und 8–15 Ziffern ein.
                </div>
              }
            </div>
          </div>

          <div class="d-flex flex-column flex-md-row">
            <small class="text-muted d-flex align-items-center form-help">
              Nach Erstellung des ersten Therapieplans erhält Ihr Patient eine E-Mail für den Zugang zu sanactivo.
            </small>

            <div class="ms-auto mt-3 mt-md-0">
              <p-button
                type="submit"
                label="Patient speichern"
                severity="primary"
                size="small"
                data-cy="sana-tp-client-add-submit"
                icon="pi pi-save"
                [disabled]="isSaving" />
            </div>
          </div>
        </form>

        <div class="d-flex flex-column">
          @for (message of messages(); track message; let first = $first) {
            <p-message
              [severity]="message.severity"
              [text]="message.content"
              class="mt-3"
              [life]="3000" />
          }
        </div>
      </div>
    </div>
  </div>
</section>

